// import {
//   User,
//   EmailAuthProvider,
//   signInWithCustomToken,
// } from "firebase/auth";
// import { firebaseAuth } from "@/providers/authProvider";

import { saveTokenExpiry } from "@/lib/session";
import { FUNCTIONS_BASE_URL } from "@/lib/config";

/**
 * auth-relay が返したエラー。code は relay が付けるエラーコード（例: email-mismatch）。
 */
export class AuthRelayError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = "AuthRelayError";
    this.code = code;
  }
}

/**
 * 中継APIを使用してメールリンク認証を行う
 */
export const signInWithEmailLinkViaAPI = async (email: string, link: string) => {
  try {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/signInWithEmailLink`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, link }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new AuthRelayError(data.error || "Failed to sign in with email link", data.code);
    }

    localStorage.setItem("idToken", data.idToken);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem("lastActive", Date.now().toString());
    saveTokenExpiry(data.expiresIn);

    return {
      success: true,
      isNewUser: data.isNewUser
    };
  } catch (error) {
    console.error("Error signing in with email link:", error);
    throw error;
  }
};

/**
 * 中継APIを使用してパスワードを更新する
 */
export const updatePasswordViaAPI = async (uid: string, password: string) => {
  try {
    const idToken = localStorage.getItem("idToken");

    if (!idToken) {
      throw new Error("Not authenticated");
    }

    const response = await fetch(`${FUNCTIONS_BASE_URL}/updatePassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify({ uid, password }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || "Failed to update password");
    }

    return { success: true };
  } catch (error) {
    console.error("Error updating password:", error);
    throw error;
  }
};

export function isSignInWithEmailLink(link: string) {
  try{
    const url = new URL(link);
    const mode = url.searchParams.get("mode");
    const oobCode = url.searchParams.get("oobCode");
    return mode === "signIn" && !!oobCode;
  } catch (error) {
    console.error("Error parsing URL:", error);
    return false;
  }
}